import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {map, tap} from "rxjs/operators";

const getSessionValue = environment.apiUrl + 'Value/--projectShortName--/';

export const HTTP_HEADERS = new HttpHeaders()
  .set('Accept', 'application/json')
  .set('Access-Control-Allow-Origin', '*');

@Injectable({
  providedIn: 'root'
})
export class SessionsService {
public sessionToken: string | null = '';
  constructor(private http: HttpClient) { }

  getSessionToken(
    projectShortName: string,
    tokenIdentifier: string
    ) {

      let url = getSessionValue.replace('--projectShortName--', projectShortName.toUpperCase());
      url = url + tokenIdentifier;
      return this.http.get<any>(url,
        {headers: HTTP_HEADERS})
        .pipe(
          tap(res => res),
          map((res) => res.result)
        );


  }

}
